import axios from "../../helpers/httpClient";
import { updateAmountWithCurrency } from './componentsActions';

export default {
    //ACTION BANCO
    requestBancos: async ({ commit, state, dispatch }, obj) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const bancos = await axios.get(`/information/private/management/consultaDatosBanco`, {
                params: {
                    perPage: (obj) ? obj.perPage : 40,
                    currentPage: (obj) ? obj.currentPage : 1,
                    dataFilter: (obj) ? obj.dataFilter : {}
                }
            }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (bancos.status === 200) {
                const obj = {
                    array: bancos.data.bancos,
                    property: 'monto_existente'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_BANCOS', newStateData);
                commit('SET_BANCOS_FILTROS', newStateData);

                commit('SET_BANCOS_EXPORT', newStateData);
                commit('SET_BANCOS_FILTERS_EXPORT', newStateData);

                commit('SET_TOTAL_BANCOS', bancos.data.totalCoincidences);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    requestBanco: async ({ commit, state, dispatch }, id) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const banco = await axios.get(`/information/private/management/consultaBanco`, {
                params: {id}
            }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (banco.status === 200) {
                return banco.data.bancoGestion
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    crearBanco: async ({ commit, dispatch, state }, bancoData) => {
        const stateBancos = state.bancos
        const stateNum = state.ultimoCodigoContableNumBanco

        try {
            // Start loader
            commit('SET_LOADER', true);

            const bancoResponse = await axios.post(`/information/private/management/crearBanco`, {
                ...bancoData,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (bancoResponse.status === 200) {

                stateBancos.push(bancoResponse.data.data)

                const obj = {
                    array: stateBancos,
                    property: 'monto_existente'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_BANCOS', newStateData);
                commit('SET_BANCOS_FILTROS', newStateData);

                commit('SET_BANCOS_EXPORT', newStateData);
                commit('SET_BANCOS_FILTERS_EXPORT', newStateData);

                commit('SET_ULTIMO_CODIGO_CONTABLE_NUM_BANCO', Number(stateNum) + 1)
                commit(
                    'SET_ULTIMO_CODIGO_CONTABLE_BANCO',
                    `1.1.1.02.${((Number(stateNum) + 1) >= 10)
                        ? (Number(stateNum) + 1)
                        : `0${(Number(stateNum) + 1)}`
                    }`
                )

                dispatch('activeMessageCorrect', bancoResponse.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    addBancosImport: async ({ commit, dispatch, state }, allBancos) => {
        const stateBancos = state.bancos

        try {
            // Start loader
            commit('SET_LOADER', true);

            const newBancos = await axios.post(`/information/private/management/addBancosImport`, {
                allBancos,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newBancos.status === 200) {

                stateBancos.push(newBancos.data.data)

                const obj = {
                    array: stateBancos,
                    property: 'monto_existente'
                };
                await dispatch('updateAmountWithCurrency', obj);

                commit('SET_BANCOS', stateBancos);
                commit('SET_BANCOS_FILTROS', stateBancos);
                
                commit('SET_BANCOS_EXPORT', stateBancos);
                commit('SET_BANCOS_FILTERS_EXPORT', stateBancos);

                dispatch('activeMessageCorrect', newBancos.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    editBanco: async ({ commit, dispatch, state }, dataBank) => {
        const stateData = state.bancos
        const stateCc = state.codigosContables

        try {
            // Start loader
            commit('SET_LOADER', true);

            const banco = await axios.post(`/information/private/management/editBanco`, {
                ...dataBank,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (banco.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_banco === banco.data.data[0].Id_banco) {
                        Object.assign(stateData[index], banco.data.data[0])
                    }
                })

                stateCc.forEach((data, index) => {
                    if (data.Codigo === banco.data.data[0].Cc_banco) {
                        stateCc[index].Referencia = dataBank.agencia
                    }
                })

                const obj = {
                    array: stateData,
                    property: 'monto_existente'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_CODIGOS_CONTABLES', stateCc);
                commit('SET_CODIGOS_CONTABLES_FILTROS', stateCc);
                commit('SET_BANCOS', newStateData);
                commit('SET_BANCOS_FILTROS', newStateData);

                commit('SET_BANCOS_EXPORT', newStateData);
                commit('SET_BANCOS_FILTERS_EXPORT', newStateData);

                dispatch('requestMovimientosBancos')
                dispatch('activeMessageCorrect', banco.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    editarBancoVuex: async ({ commit, dispatch, state }, codigo) => {
        const stateData = state.bancos
        const stateCc = state.codigosContables

        try {
            // Start loader
            commit('SET_LOADER', true);

            const banco = await axios.post(`/information/private/management/editarBanco`, {
                ...codigo,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (banco.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_banco === banco.data.data[0].Id_banco) {
                        Object.assign(stateData[index], banco.data.data[0])
                    }
                })

                stateCc.forEach((data, index) => {
                    if (data.Codigo === banco.data.data[0].Cc_banco) {
                        stateCc[index].Referencia = codigo.nombre
                    }
                })

                const obj = {
                    array: stateData,
                    property: 'monto_existente'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_CODIGOS_CONTABLES', stateCc);
                commit('SET_CODIGOS_CONTABLES_FILTROS', stateCc);
                commit('SET_BANCOS', newStateData);
                commit('SET_BANCOS_FILTROS', newStateData);

                commit('SET_BANCOS_EXPORT', newStateData);
                commit('SET_BANCOS_FILTERS_EXPORT', newStateData);

                dispatch('requestMovimientosBancos')
                dispatch('activeMessageCorrect', banco.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    eliminarBancoVuex: async ({ commit, dispatch, state }, bancoData) => {
        const bancos = state.bancos
        const codigosContables = state.codigosContables

        try {
            // Start loader
            commit('SET_LOADER', true);

            const eliminarBancoResponse = await axios.post(`/information/private/management/eliminarBanco`, {
                ...bancoData,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (eliminarBancoResponse.status === 200) {
                if (eliminarBancoResponse.data.message === 'Error movimientos existentes') {
                    dispatch('activeMessageError', eliminarBancoResponse.data.message)
                } else {
                    bancos.forEach((data, index) => {
                        if (data.Id_banco === bancoData.idCodigo) {
                            bancos.splice(index, 1)
                        }
                    })
    
                    codigosContables.forEach((data, index) => {
                        if (data.Codigo === bancoData.codigo) {
                            codigosContables.splice(index, 1)
                        }
                    })

                    const obj = {
                        array: bancos,
                        property: 'monto_existente'
                    };

                    let newStateData = await dispatch('updateAmountWithCurrency', obj);
    
                    commit('SET_BANCOS', newStateData);
                    commit('SET_BANCOS_FILTROS', newStateData);

                    
                    commit('SET_BANCOS_EXPORT', newStateData);
                    commit('SET_BANCOS_FILTERS_EXPORT', newStateData);

                    commit('SET_CODIGOS_CONTABLES', codigosContables);
                    commit('SET_CODIGOS_CONTABLES_FILTROS', codigosContables);
                    dispatch('activeMessageCorrect', eliminarBancoResponse.data.message)
                }

                return eliminarBancoResponse
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    resetStatusApiBanco: async ({ commit }) => {
        commit('SET_STATUS_API_BANCO', { message: "", success: "" })
    },
    //ACTION MOVIMIENTOS BANCOS
    requestMovimientosBancos: async ({ commit, state, dispatch }, obj) => {

        try {
            // Start loader
            commit('SET_LOADER', true);

            const bancos = await axios.get(`/information/private/management/consultaDatosMovimientoBanco`, {
                params: {
                    perPage: (obj) ? obj.perPage : 40,
                    currentPage: (obj) ? obj.currentPage : 1,
                    dataFilter: (obj) ? obj.dataFilter : {}
                }
            }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (bancos.status === 200) {
                const obj = {
                    array: bancos.data.movimientoBanco,
                    property: 'Cantidad'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_MOVIMIENTOS_BANCOS', newStateData);
                commit('SET_MOVIMIENTOS_BANCOS_FILTROS', newStateData);

                commit('SET_MOVIMIENTOS_BANCOS_EXPORT', newStateData);
                commit('SET_MOVIMIENTOS_BANCOS_FILTERS_EXPORT', newStateData);

                commit('SET_TOTAL_MOVIMIENTOS_BANCO', bancos.data.totalCoincidences);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    createMovement: async ({ state, dispatch, commit }, arregloTodosLosMovimientos) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let movimientos = await axios.post(`/information/private/management/crearMovimientoCaja`, {
                arregloInformacion: arregloTodosLosMovimientos,
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (movimientos.status === 200) {
                dispatch('activeMessageCorrect', movimientos.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    editMovement: async ({ state, dispatch, commit }, arregloTodosLosMovimientos) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let movimientos = await axios.post(`/information/private/management/editarMovimientoCaja`, {
                arregloInformacion: arregloTodosLosMovimientos,
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (movimientos.status === 200) {
                dispatch('activeMessageCorrect', movimientos.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    editAccountingCode: async ({ state, dispatch, commit }, object) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const {codigoContableNuevo, codigoContableNombreNuevo, codigoContableNombreMemoria, codigoContableRelacionMemoria, tipoCodigoColorNuevo, idCodigo, codigoContableMemoria} = object;

            let codigoContableRes = await axios.post(`/information/private/management/editarCodigoContable`, {
                codigo: codigoContableNuevo,
                nombre: codigoContableNombreNuevo,
                nombreMemoria: codigoContableNombreMemoria,
                relacionMemoria: codigoContableRelacionMemoria,
                tipoCodigo: tipoCodigoColorNuevo,
                idCodigo: idCodigo,
                memoria: codigoContableMemoria,
            });

            // Stop Loader
            commit('SET_LOADER', false);

            return codigoContableRes;
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    deleteAccountingCode: async ({ state, dispatch, commit }, id, codigo, nombre, tipo) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let codigoContableResponse = await axios.post(`/information/private/management/eliminarCodigoContable`, {
                idCodigo: id,
                codigo: codigo,
                nombre: nombre,
                tipo: tipo,
            });

            // Stop Loader
            commit('SET_LOADER', false);

            return codigoContableResponse;
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    editBankMovement: async ({ state, dispatch, commit }, idInicialesEdicion, relacionIdPadre, arregloTodosLosMovimientos2) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let editarMovimientosBancoResponse = await axios.post(`/information/private/management/editarMovimientoBanco`, {
                idsEdicion: idInicialesEdicion,
                idPadre: relacionIdPadre,
                arregloInformacion2: arregloTodosLosMovimientos2,
            });

            // Stop Loader
            commit('SET_LOADER', false);

            return editarMovimientosBancoResponse;
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addMovementsBancoImport: async ({ state, dispatch, commit }, dataArray) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let movements = await axios.post(`/information/private/management/addMovementsImport`, {
                dataArray,
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (movements.status === 200) {
                dispatch('activeMessageCorrect', movements.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    }
}